import React from 'react';
import { CheckCircleIcon, UploadIcon, ClockIcon, FileTextIcon, UserPlusIcon } from 'lucide-react';
import { Loan } from '../types/loan.types';
interface ActivityTabProps {
  loan: Loan;
}
interface Activity {
  id: string;
  type: 'upload' | 'approval' | 'status_change' | 'created';
  description: string;
  timestamp: string;
  icon: React.ElementType;
  iconColor: string;
  iconBg: string;
}
export function ActivityTab({
  loan
}: ActivityTabProps) {
  // Generate activities based on loan documents
  const activities: Activity[] = [...loan.requiredDocuments.filter(doc => doc.status !== 'missing').map((doc, index) => ({
    id: `activity-${doc.id}`,
    type: 'upload' as const,
    description: `${doc.name} ${doc.status === 'approved' ? 'approved' : 'uploaded'}`,
    timestamp: doc.uploadedDate || 'Recently',
    icon: doc.status === 'approved' ? CheckCircleIcon : UploadIcon,
    iconColor: doc.status === 'approved' ? 'text-emerald-600' : 'text-blue-600',
    iconBg: doc.status === 'approved' ? 'bg-emerald-50' : 'bg-blue-50'
  })), {
    id: 'activity-created',
    type: 'created' as const,
    description: 'Loan application received from brokerage',
    timestamp: 'Jan 5, 2024',
    icon: FileTextIcon,
    iconColor: 'text-gray-600',
    iconBg: 'bg-gray-50'
  }];
  return <div className="space-y-6" data-id="element-1">
      <div data-id="element-2">
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-3">
          Activity Timeline
        </h3>
        <p className="text-sm text-gray-600 mt-1" data-id="element-4">
          Recent actions and updates for this loan
        </p>
      </div>

      <div className="flow-root" data-id="element-5">
        <ul className="-mb-8" data-id="element-6">
          {activities.map((activity, activityIdx) => {
          const Icon = activity.icon;
          return <li key={activity.id} data-id="element-7">
                <div className="relative pb-8" data-id="element-8">
                  {activityIdx !== activities.length - 1 ? <span className="absolute left-5 top-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" data-id="element-9" /> : null}
                  <div className="relative flex items-start space-x-3" data-id="element-10">
                    <div className="relative" data-id="element-11">
                      <div className={`h-10 w-10 rounded-full ${activity.iconBg} flex items-center justify-center ring-4 ring-white`} data-id="element-12">
                        <Icon className={`h-5 w-5 ${activity.iconColor}`} aria-hidden="true" data-id="element-13" />
                      </div>
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-14">
                      <div data-id="element-15">
                        <p className="text-sm font-medium text-gray-900" data-id="element-16">
                          {activity.description}
                        </p>
                        <p className="mt-0.5 text-xs text-gray-500" data-id="element-17">
                          {activity.timestamp}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>

      {activities.length === 1 && <div className="text-center py-8 text-gray-500" data-id="element-18">
          <ClockIcon className="w-12 h-12 mx-auto mb-3 text-gray-300" data-id="element-19" />
          <p className="text-sm" data-id="element-20">No recent activity yet</p>
        </div>}
    </div>;
}